import React, { useEffect, startTransition } from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { Modal } from 'react-responsive-modal';
import getProperImageData from 'utils/getProperImageData';
import usePopup from 'utils/hooks/usePopup';
import { pushGTMClosingPopupComponent } from 'utils/gtm';

import DS_ButtonLink from 'mui/components/elements/DS_ButtonLink';
import RichText from '../RichText';

import DS_BasicCard from '../../../mui/components/elements/DS_BasicCard';

const LANGUAGE = process.env.GATSBY_COUNTRY_CODE;

const Popup = ({
  text,
  button,
  headline,
  closeSentence,
  pagesToAvoidPopup,
  image,
  isNewVersion,
  deactivateInAllPages,
  isMergeVersion,
  leadText,
  gtmTrackingInfo = {},
}) => {
  const { popupIsVisible, closePopup } = usePopup(pagesToAvoidPopup, isMergeVersion, deactivateInAllPages);
  const { title, url } = button;
  const properImage = getProperImageData(image);

  useEffect(() => {
    import('react-responsive-modal/styles.css');
  }, []);

  const closingPopup = () => {
    pushGTMClosingPopupComponent({
      title,
      lang: LANGUAGE,
    });

    startTransition(() => {
      closePopup();
    });
  };

  return (
    <Modal
      style={{ background: isNewVersion ? `white` : `transparent` }}
      classNames={{
        modal: isMergeVersion ? 'popup_modal impress' : 'popup_modal', // styles in global styles
      }}
      open={popupIsVisible}
      onClose={closingPopup}
      center
      showCloseIcon={!isNewVersion}
      closeOnEsc={true}
    >
      {isNewVersion || isMergeVersion ? (
        <StyledNewContent>
          <DS_BasicCard sx={{ margin: `0px 20px 0`, position: `relative`, zIndex: 3 }}>
            <StyledImageWrapper isMergeVersion={isMergeVersion} data-test="popup-img-wrapper">
              <GatsbyImage image={properImage?.gatsbyImageData} alt="popup image" />
            </StyledImageWrapper>
            {isNewVersion && !isMergeVersion && (
              <Typography variant="DS_h3" component="h3">
                {headline}
              </Typography>
            )}

            <Typography variant={isMergeVersion ? 'DS_h3' : 'DS_copyBigRegular'} component="p">
              {text}
            </Typography>
            {isMergeVersion && <RichText document={leadText} />}
            {isNewVersion && !isMergeVersion && (
              <DS_ButtonLink
                title={title}
                url={url}
                gtmTrackingInfo={gtmTrackingInfo}
                gtmEvent={{
                  eventAction: 'CTA popup',
                  eventCategory: 'Booking funnel',
                }}
              />
            )}
            {isMergeVersion && (
              <StyledMergedButtons>
                <DS_ButtonLink
                  title={closeSentence}
                  onClick={closingPopup}
                  gtmTrackingInfo={gtmTrackingInfo}
                  gtmEvent={{
                    eventAction: 'CTA popup',
                    eventCategory: 'Booking funnel',
                  }}
                />
                <DS_ButtonLink
                  title={title}
                  url={url}
                  buttonVariant="outlined"
                  gtmTrackingInfo={gtmTrackingInfo}
                  gtmEvent={{
                    eventAction: 'CTA popup',
                    eventCategory: 'Booking funnel',
                  }}
                />
              </StyledMergedButtons>
            )}
            {isNewVersion && !isMergeVersion && (
              <StyledButton onClick={closingPopup}>
                <Typography variant="DS_copySmallRegular" component="button">
                  {closeSentence}
                </Typography>
              </StyledButton>
            )}
          </DS_BasicCard>
        </StyledNewContent>
      ) : (
        <DS_BasicCard>
          <Typography sx={{ margin: `32px 12px 24px` }} variant="DS_copyBigRegular" component="p">
            {text}
          </Typography>
          <DS_ButtonLink
            title={title}
            url={url}
            gtmTrackingInfo={gtmTrackingInfo}
            gtmEvent={{
              eventAction: 'CTA popup',
              eventCategory: 'Booking funnel',
            }}
          />
        </DS_BasicCard>
      )}
    </Modal>
  );
};

export default Popup;

export const StyledButton = styled('div')(
  ({ theme }) => `
  margin-top: 20px;
  button {
     color: ${theme.DS_palette.buttons.enabled};
     text-decoration: underline;
  }  
`,
);
export const StyledImageWrapper = styled('div')(
  ({ theme, isMergeVersion }) => `

       .gatsby-image-wrapper {
        > div {
          max-width: ${isMergeVersion ? '244px !important' : 'inherit'}
        }
         img {
         border-radius: ${theme.DS_border.radius.img};
         }
      }
`,
);

export const StyledNewContent = styled('div')(
  ({ theme }) => `

  
      h3 {
        margin-top: ${theme.DS_spacing(['sm'])};
      }
      
      p{
        margin: 12px 0 ${theme.DS_spacing(['sm'])};
      }
     
       .gatsby-image-wrapper {
         img {
         border-radius: ${theme.DS_border.radius.img};
         }
      }
`,
);

export const StyledMergedButtons = styled('div')(
  ({ theme }) => `
      margin-top: ${theme.DS_spacing(['md'])};
      a:last-of-type {
        margin-top: ${theme.DS_spacing(['xs'])};
        max-width: 100%;
        min-width: 100%;
      }
`,
);
